import { render, staticRenderFns } from "./TenantTest.vue?vue&type=template&id=12ae1ace&scoped=true"
import script from "./TenantTest.vue?vue&type=script&lang=js"
export * from "./TenantTest.vue?vue&type=script&lang=js"
import style0 from "./TenantTest.vue?vue&type=style&index=0&id=12ae1ace&prod&scoped=true&lang=css"
import style1 from "./TenantTest.vue?vue&type=style&index=1&id=12ae1ace&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ae1ace",
  null
  
)

export default component.exports